import React, { FC, useState } from "react";
import { Card, CardContent } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useRouter } from "next/router";
import { NextSwiperArrow, PrevSwiperArrow } from "@/components/icons";

interface TopHotelsProps {
  topHotelsData: {
    heading: string;
    hotels: {
      id: number;
      image: string;
      location: string;
      name: string;
    }[];
  };
}

const TopHotels: FC<TopHotelsProps> = ({ topHotelsData }) => {
  const [swiperInstance, setSwiperInstance] = useState<any>(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const router = useRouter();
  const isRtl = router.locale === "ar";
  const handleSwiper = (swiper: any) => {
    setSwiperInstance(swiper);
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  const handleSlideChange = (swiper: any) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  return (
    <section className="flex flex-col w-full max-w-[1328px] px-4 items-start c-lg:gap-12 gap-2 relative mx-auto">
      <header className="items-center w-full flex relative">
        <h2 className="c-lg:text-[40px] text-2xl  font-bold text-primary leading-10">
          {topHotelsData.heading}
        </h2>
      </header>

      <div
        className={`swiper-button-prev-custom swiper-button-prev-custom-A transition-opacity duration-200 ${
          isBeginning ? "opacity-0 pointer-events-none" : "opacity-100"
        }`}
      >
        <PrevSwiperArrow />
      </div>
      <div
        className={`swiper-button-next-custom swiper-button-next-custom-A transition-opacity duration-200 ${
          isEnd ? "opacity-0 pointer-events-none" : "opacity-100"
        }`}
      >
        <NextSwiperArrow />
      </div>

      <div className="overflow-hidden max-w-[1312px] py-5">
        <Swiper
          dir={isRtl ? "rtl" : "ltr"}
          key={isRtl ? "rtl" : "ltr"}
          spaceBetween={16}
          slidesPerView={1}
          slidesPerGroup={1}
          breakpoints={{
            360: {
              slidesPerView: 1,
              spaceBetween: 8,
              centeredSlides: true,
            },
            414: {
              slidesPerView: 1.1,
              spaceBetween: 16,
            },
            640: {
              slidesPerView: 2.5,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 3.5,
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: 4.4,
              spaceBetween: 16,
            },
          }}
          navigation={{
            nextEl: ".swiper-button-next-custom-A",
            prevEl: ".swiper-button-prev-custom-A",
          }}
          modules={[Navigation]}
          className="mySwiper "
          onSwiper={handleSwiper}
          onSlideChange={handleSlideChange}
          onReachEnd={() => setIsEnd(true)}
          onReachBeginning={() => setIsBeginning(true)}
        >
          {topHotelsData.hotels.map((hotel) => (
            <SwiperSlide key={hotel.id}>
              <Card className="flex-shrink-0 sm:w-[276px] w-[90vw] max-w-inherit  h-[360px] !p-0 overflow-hidden !rounded-xl !border-none !shadow-md relative">
                <CardContent className="!p-0 h-full relative">
                  <div
                    className="  w-full h-full bg-cover bg-center object-fit"
                    style={{ backgroundImage: `url(${hotel.image})` }}
                  >
                    <div className="absolute bottom-0 left-0 w-full h-[198px] bg-gradient-to-t from-black/70 to-transparent" />

                    <div className="absolute bottom-5 ltr:left-4 rtl:right-4 flex flex-col items-start justify-between c-lg:w-[244px] w-[90%] h-[54px]">
                      <h3 className="text-white font-black text-xl text-center w-full">
                        {hotel.location}
                      </h3>
                      <p className="text-white font-bold text-base text-center w-full">
                        {hotel.name}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TopHotels;
